<template>
    <div>

        <div class="form-group row align-items-center">
            <label class="col-form-label text-md-right col-md-2">Група</label>
            <div class="col-md-9">
                <multiselect
                    v-model="group"
                    label="name"
                    track-by="id"
                    :options="groups"
                    :multiple="true"
                    open-direction="bottom"
                    @input="getPrograms">
                </multiselect>
            </div>
        </div>

        <div class="form-group row align-items-center" v-if="group.length">
            <label class="col-form-label text-md-right col-md-2">Програма</label>
            <div class="col-md-9">
                <multiselect
                    v-model="program"
                    label="name"
                    track-by="id"
                    :options="programs"
                    :multiple="true"
                    open-direction="bottom">
                </multiselect>
            </div>
        </div>

        <div class="form-group row" v-if="group.length">
            <label class="col-form-label text-md-right col-md-2">Дата початку </label>
            <div class="col-md-9">
                <div class="input-group input-group--custom">
                    <div class="input-group-addon"><i class="fa fa-clock-o"></i></div>
                    <datetime
                        v-model="start"
                        class="flatpickr">
                    </datetime>
                </div>
            </div>
        </div>

        <div class="form-group row" v-if="group.length">
            <label class="col-form-label text-md-right col-md-2">Дата кінця </label>
            <div class="col-md-9">
                <div class="input-group input-group--custom">
                    <div class="input-group-addon"><i class="fa fa-clock-o"></i></div>
                    <datetime
                        v-model="end"
                        class="flatpickr">
                    </datetime>
                </div>
            </div>
        </div>

        <div class="row" v-if="group.length">
            <button class="btn btn-primary btn-spinner btn-sm pull-right m-b-0" @click="getReportVisitingMissingStudents" id="get_report" :disabled="button_disabled" type="button">
                Завантажити звіт
            </button>	&nbsp;	&nbsp;

            <button class="btn btn-primary btn-spinner btn-sm pull-right m-b-0" @click="saveReportVisitingMissingStudents" id="save_report" :disabled="button_disabled" type="button">
                Зберегти звіт
            </button>
            <br>
            <br>
        </div>

        <div class="row">
            <br>
            <div class="table-reports" v-if="data_academies!==null">
                <table class="table is_middle table-condensed table-bordered">
                    <template v-for="academy in data_academies">
                        <tr>
                            <td style="background: #ccc">{{academy.name}}</td>
                        </tr>
                        <template v-for="group in academy.groups">

                            <tr class="teachers_group">
                                <td style="background: #eee">{{ group.name }}</td>
                            </tr>

                            <template v-for="(student, index) in group.students">

                                <tr v-if="student.activity_false.length">
                                    <td>
                                        {{ student.full_name }}
                                    </td>
                                    <td v-for="activity in student.activity_false">
                                        {{ activity.day }}
                                    </td>
                                </tr>
                            </template>
                        </template>
                    </template>
                </table>
            </div>
            <div v-if="count_academies===0">
                Даних не знайдено
            </div>
        </div>
    </div>

</template>
<style scoped>
    .table-reports{
        overflow-x: scroll;
        max-width: 100%;
    }
    .table-reports tr td {
        padding: 8px;
        min-width: 95px;
    }
    .table-reports tr td:first-child {
        min-width: 210px;
    }
</style>

<script>
    import axios from "axios";

    export default {
        name: "TeacherReportsVisitingMissingStudentsComponent",
        props: ['groups', 'start', 'end'],
        data() {
            return {
                group: [],
                programs: [],
                program: [],
                start_date: '',
                finish_date: '',
                data_academies: null,
                count_academies: '',
                button_disabled: false
            }
        },
        computed: {},
        methods: {

            async getPrograms(){
                const { data: { programs } } = await axios.post('/teacher/dashboard/reports/getPrograms', {
                    'groups': this.group,
                });
                this.programs = programs;
            },

            async getReportVisitingMissingStudents(){
                this.button_disabled = true
                try {
                    const { data: { academies } } = await axios.post('/teacher/dashboard/reports/getReportVisitingMissingStudents', {
                        'groups': this.group,
                        'programs': this.program
                    });
                    this.button_disabled = false
                    this.data_academies = academies;
                    this.count_academies = academies.length;
                } catch  (err) {
                    this.button_disabled = false
                    console.log(err,message)
                }
            },

            async saveReportVisitingMissingStudents(){
                this.button_disabled = true
                try {
                    const { data: { file_name } } = await axios.post('/teacher/dashboard/reports/getReportVisitingMissingStudents', {
                        'groups': this.group,
                        'programs': this.program,
                        'save': true,
                    });
                    this.button_disabled = false
                    location.href = file_name;

                } catch  (err) {
                    this.button_disabled = false
                    console.log(err,message)
                }
            }

        }
    }
</script>
